import { gql } from "apollo-boost"

export const CREATE_PROJECT_MONTH_STATUS_QUERY = gql`
    mutation CreateProjectMonthStatus ($submissionId: ID!, $data: CreateProjectMonthStatusInput!) {
        CreateProjectMonthStatusData(submissionId: $submissionId, data: $data )
    }
`
